// import { ChildrenStoreData, LoginSessionStateType, LoginStorageData, PersistLoginStateType } from '@parent-app/types';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ChildrenStoreData, LoginSessionStateType, LoginStorageData, NurseryGroupStoreData, PersistLoginStateType } from 'src/shared/types/src';

const initialState: LoginSessionStateType = {
    isLoggedIn: false,
    isAuthLoading: false
} as LoginSessionStateType;

const persistState: PersistLoginStateType = {
    isUpdateCurrentChildLoading: false
} as PersistLoginStateType;

const loginSlice = createSlice({
    name: 'loginSlice',
    initialState,
    reducers: {
        setIsLoggedIn: (state, action: PayloadAction<boolean>) => {
            state.isLoggedIn = action.payload;
        },
        setAuthLoading: (state, action: PayloadAction<boolean>) => {
            state.isAuthLoading = action.payload;
        },
        resetLoginState: () => {
            return initialState;
        }
    }
});

const persistLoginSlice = createSlice({
    name: 'persistLoginSlice',
    initialState: persistState,
    reducers: {
        setLoginData: (state, action: PayloadAction<LoginStorageData>) => {
            state.loginData = action.payload;
        },
        setGroupedByNursery: (state, action: PayloadAction<NurseryGroupStoreData[]>) => {
            state.groupedByNursery = action.payload;
        },
        setCurrentChild: (state, action: PayloadAction<ChildrenStoreData>) => {
            state.currentChild = action.payload;
        },
        setTermsAccepted: (state, action: PayloadAction<boolean>) => {
            state.loginData.termsAccepted = action.payload;
        },
        setShowAppTour: (state, action: PayloadAction<boolean>) => {
            state.loginData.showAppTour = action.payload;
        },
        setUpdateCurrentChildLoading: (state, action: PayloadAction<boolean>) => {
            state.isUpdateCurrentChildLoading = action.payload;
        },
        resetPersistLoginState: () => {
            return persistState;
        },
        setCurrentNursery: (state, action: PayloadAction<NurseryGroupStoreData>) => {
            state.currentNursery = action.payload;
        }
    }
});

export const LoginActions = loginSlice.actions;
export const LoginPersistActions = persistLoginSlice.actions;
export const loginReducer = loginSlice.reducer;
export const loginPersistReducer = persistLoginSlice.reducer;
